<script>
import {monthMap} from "@/lib";
import {mapActions} from "vuex";

export default {
  name: "KonzessionsAbgabenRow",
  props: ["konzessionsabgabe"],
  computed: {
    month() {
      const monat = this.konzessionsabgabe.monat;
      if(!monat) return undefined;

      return monthMap[monat];
    },
    filename() {
      return `${this.konzessionsabgabe.kommune} ${this.konzessionsabgabe.dokumenttyp} ${this.konzessionsabgabe.sparte} ${this.month ?? ""} ${this.konzessionsabgabe.jahr}.pdf`.replaceAll("  ", " ");
    }
  },
  data: () => ({
    downloading: false
  }),
  methods: {
    ...mapActions('konzessionsthemen', ['downloadTestat', 'markAsRead']),
    async downloadFile() {
      try {
        this.downloading = true;
        await this.downloadTestat({ id: this.konzessionsabgabe.osid, filename: this.filename });
        this.markAsRead(this.konzessionsabgabe.osid);
      } finally {
        this.downloading = false;
      }
    }
  },
}
</script>

<template>
  <v-sheet class="pa-3 mt-3" elevation="1">
    <v-row class="document-row" :class="konzessionsabgabe.isNewEntry ? 'unread-row' : 'read-row'">
      <v-col cols="3" class="py-0 px-2 d-flex align-center" :class="konzessionsabgabe.isNewEntry ? 'primary-text font-weight-bold' : ''">
        {{ konzessionsabgabe.kommune }}
      </v-col>
      <v-col cols="3" class="py-0 px-2 d-flex align-center" :class="konzessionsabgabe.isNewEntry ? 'primary-text font-weight-bold' : ''">
        {{ konzessionsabgabe.dokumenttyp }} {{ konzessionsabgabe.sparte }}
      </v-col>
      <v-col cols="1" class="py-0 px-2 d-flex align-center justify-end pr-5" :class="konzessionsabgabe.isNewEntry ? 'primary-text font-weight-bold' : ''">
        <span style="width: 50px; text-align: left;">
        {{ konzessionsabgabe.jahr }}
        </span>
      </v-col>
      <v-col cols="1" class="py-0 px-2 d-flex align-center" :class="konzessionsabgabe.isNewEntry ? 'primary-text font-weight-bold' : ''">
        {{ month }}
      </v-col>
      <v-col cols="2" class="py-0 px-2 d-flex align-center">
        <v-btn text small class="mx-0 px-0" @click="downloadFile" :loading="downloading">
          <v-icon color="primary" small left>$download</v-icon>
          Herunterladen
        </v-btn>
      </v-col>
      <v-col cols="2" class="py-0 px-2 d-flex align-center" :class="konzessionsabgabe.isNewEntry ? 'primary-text font-weight-bold' : ''">
        <v-icon left>
          {{ konzessionsabgabe.isNewEntry ? '$unread' : '$read' }}
        </v-icon>
        {{ konzessionsabgabe.isNewEntry ? 'Ungelesen' : "Abgerufen"}}
      </v-col>
    </v-row>
  </v-sheet>
</template>

<style scoped>
.document-row div {
  min-height: 40px;
}

.unread-row {
  border-left: 4px solid #b40055;
}

.read-row {
  border-left: 4px solid transparent;
}
</style>